import { useAccount } from "../../hooks/hooks/use-account.js";
import { AuthState } from "../../state.js";
const IsLoggedIn = ({ children }) => {
  const authState = useAccount();
  const isLoggedIn = authState === AuthState.LoggedIn;
  if (!isLoggedIn) {
    return null;
  }
  return children;
};
export {
  IsLoggedIn as default
};
//# sourceMappingURL=IsLoggedIn.js.map
